module.exports = __webpack_public_path__ + "img/manos-acelerator-logo.dd9dd5f0.png";